import Service from '@/service'

import UserInfo from '@/data/user_info'
const navigate = () => {}

export const updateUserInfo = (detail, success) => {
    wx.showLoading()
    UserInfo.set(detail.userInfo)
    Service.updateWxUserInfo(detail).then(success)
    wx.hideLoading()
}

export const getUserInfo = ({ mp }, success, failTip) => {
    if (UserInfo.isAuthed()) {
        success()
        return
    }
    const { userInfo } = mp.detail
    if (userInfo) {
        updateUserInfo(mp.detail, success)
    } else {
        wx.showModal({
            title: '提示',
            content: failTip || '您需要授权才能进行此操作',
            showCancel: false
        })
    }
}

export const askAuth = ({ mp }, success) => {
    const { userInfo } = mp.detail
    if (UserInfo.isAuthed() || !userInfo) {
        success()
        return
    }
    updateUserInfo(mp.detail, success)
}

export const askAuthNavigator = (e, url) => {
    navigate(url)
}

export const getAuthNavigator = ({ mp }, url) => {
    const { userInfo } = mp.detail
    if (userInfo && !UserInfo.isAuthed()) {
        updateUserInfo(mp.detail)
    }
    navigate(url)
}

export default getUserInfo
